// Arabic documents-stream strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enDocuments } from './en-documents.ts';
import type { Message } from './types.ts';

export const arDocuments: { readonly [K in keyof typeof enDocuments]: Message } = {
  'prereg.doc.validUntil': 'صالح حتى {date}.',
  'prereg.doc.validUntilField': 'صالح حتى (كما هو مطبوع على المستند)',
  'prereg.doc.validUntilHint': 'تستمر زيارتك حتى {through}؛ ويجب أن يكون المستند صالحًا حتى ذلك اليوم على الأقل.',
  'prereg.doc.expiresBeforeVisit': 'هذا المستند صالح حتى {validUntil}، لكن زيارتك تستمر حتى {through}. يرجى رفع مستند صالح حتى {through} على الأقل.',
  'prereg.host.expired': '{document}: صالح حتى {validUntil}، وتستمر الزيارة حتى {through}.',
  'prereg.host.nextAction': 'تبقى المراجعة السابقة مسجّلة. يمكن للزائر رفع مستند أحدث من تصريح الزيارة، أو يمكن للاستقبال مراجعة مستند عند الوصول.',
  'prereg.host.noticed': 'تم إبلاغك: {status}.',
  'prereg.host.notice.queued': 'قيد الإرسال',
  'prereg.host.notice.accepted': 'أُرسل',
  'prereg.host.notice.failed': 'لم يُرسل بعد (ستُعاد المحاولة)',
  'prereg.host.notice.blocked': 'لم يُرسل (لا يوجد قالب بلغتك)',
  'prereg.host.notice.none': 'لم يُرسل (لا يوجد بريد إلكتروني مسجّل)',
  'vpolicy.pr.docValidUntil': 'طلب تاريخ الصلاحية',
  'ver.doc.validUntil': 'صالح حتى {date}',
  'ver.doc.validUntilMissing': 'لم يُسجّل تاريخ صلاحية',
  'ver.doc.validUntilField': 'صالح حتى',
  'ver.doc.validSource.visitor': 'حسب ما ذكره الزائر',
  'ver.doc.validSource.reviewer': 'أكّده مراجِع',
  'ver.doc.correctValidity': 'تصحيح الصلاحية',
  'comms.key.host_readiness_changed': 'مستند لم يعد يغطي الزيارة (للمضيف)',
  'comms.key.evidence_expiring': 'قرب انتهاء صلاحية مستندات المقاول',
  'doc.mail.header': 'امتثال المقاولين',
  'doc.mail.role.owner_host': 'الراعي المسؤول عن الشركة',
  'doc.mail.role.coordinator': 'مسؤول عن المقاولين ولا يوجد راعٍ لهذه الشركة',
  'ctr.ui.alertRaised': 'أُطلق في {date}',
  'ctr.ui.alertNotice': '{name} ({role}): {status}',
  'ctr.ui.alertRole.owner_host': 'الراعي',
  'ctr.ui.alertRole.coordinator': 'مسؤول المقاولين',
  'ctr.ui.noticeStatus.queued': 'قيد الإرسال',
  'ctr.ui.noticeStatus.accepted': 'أُرسل',
  'ctr.ui.noticeStatus.failed': 'لم يُرسل بعد',
  'ctr.ui.noticeStatus.blocked': 'لم يُرسل',
  'ctr.col.acceptedIssuers': 'الجهات المصدِرة المقبولة',
  'ctr.col.reviewers': 'المراجِعون',
  'ctr.ui.issuersHint': 'جهة مصدِرة واحدة في كل سطر. اتركه فارغًا لقبول أي جهة.',
  'ctr.ui.reviewerExperiences': 'الأدوار',
  'ctr.ui.reviewerExperiencesHint': 'رموز الأدوار مفصولة بفواصل (مثل permit). اتركه فارغًا لأي شخص مخوّل بالبتّ في مستندات المقاولين.',
  'ctr.ui.reviewerGroups': 'مجموعات الموافقين',
  'ctr.ui.reviewerGroupsHint': 'مفاتيح مجموعات الموافقين مفصولة بفواصل. اتركه فارغًا لأي شخص مخوّل بالبتّ في مستندات المقاولين.',
  'ctr.v.issuerNotAccepted': 'هذه الجهة المصدِرة ليست ضمن القائمة المقبولة لنوع المستند هذا.',
  'ctr.v.unknownExperience': 'استخدم رمز دور لموظف.',
  'ctr.v.duplicateIssuer': 'هذه الجهة المصدِرة مدرجة بالفعل.',
  'ctr.v.unknownGroup': 'لا توجد مجموعة موافقين نشطة بهذا المفتاح.',
  'ctr.api.reviewerNotAssigned': 'لست مكلّفًا بمراجعة هذا النوع من المستندات.',
};
